import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { AI_AGENTS_MAX_FORM_LIMIT } from '../lib/constants';

export const useFormSchema = () => {
  const { t } = useTranslation('translation');

  const requiredMessage = t('common.formErrors.required');
  const maxNameMessage = t('common.formErrors.stringMaxLen', {
    max: AI_AGENTS_MAX_FORM_LIMIT.name,
  });

  const baseFields = z.object({
    name: z
      .string()
      .trim()
      .min(1, requiredMessage)
      .max(AI_AGENTS_MAX_FORM_LIMIT.name, maxNameMessage),
  });

  return baseFields;
};
